import Appointments from 'Pages/Admin/Appointments';
import Dashboard from 'Pages/Admin/Dashboard';
import DoctorList from 'Pages/Admin/DoctorList';
import DoctorDetail from 'Pages/Admin/DoctorList/DoctorDetail';
import Enterprise from 'Pages/Admin/Enterprise';
import EnterpriseDetail from 'Pages/Admin/Enterprise/EnterpriseDetail';
import StaffDetail from 'Pages/Admin/Enterprise/EnterpriseDetail/StaffDetail';
import UserDetail from 'Pages/Admin/Enterprise/EnterpriseDetail/StaffDetail/UserDetail';
import LeadCapture from 'Pages/Admin/LeadCapture';
import LeadCaptureDetail from 'Pages/Admin/LeadCapture/LeadCaptureDetail';
import PatientList from 'Pages/Admin/Patients';
import PatientDetail from 'Pages/Admin/Patients/PatientDetail';
import PracticeList from 'Pages/Admin/Practices';
import PracticeDetail from 'Pages/Admin/Practices/PracticeDetail';
import Product from 'Pages/Admin/Product';
import Questionnaire from 'Pages/Admin/Questionnaire';
import QuestionnaireDetail from 'Pages/Admin/Questionnaire/QuestionnaireDetail';
import AdminRequest from 'Pages/Admin/Requests';
import RequestDetail from 'Pages/Admin/Requests/RequestDetail';
import Revenue from 'Pages/Admin/Revenue';
import Setting from 'Pages/Admin/Setting';
import SkinAnalyser from 'Pages/Admin/SkinAnalyser';
import SkinAnalyserDetail from 'Pages/Admin/SkinAnalyser/SkinAnalyserDetail';
import ScanResult from 'Pages/Admin/SkinAnalyser/SkinAnalyserDetail/ScanResult';
import EnterpriseDashboard from 'Pages/EnterpriseAdmin/Dashboard';
import EnterpriseLocation from 'Pages/EnterpriseAdmin/Location';
import EnterprisePatients from 'Pages/EnterpriseAdmin/Patients';
import EnterpriseProducts from 'Pages/EnterpriseAdmin/Products';
import EnterpriseStaff from 'Pages/EnterpriseAdmin/Staff';
import Login from 'Pages/Login';
import Otp from 'Pages/Otp';
import RegisterSuccess from 'Pages/RegisterSuccess';
import SetupPassword from 'Pages/SetupPassword';
import {
  login,
  registerSuccess,
  dashboard,
  request,
  doctor,
  practices,
  patients,
  questionnaire,
  products,
  setting,
  practicesDetail,
  questionnaireDetail,
  doctorDetail,
  patientsDetail,
  requestDetailValue,
  requestDetail,
  appointments,
  revenueStream,
  otp,
  skinAnalyser,
  skinAnalyserDetail,
  scanResult,
  enterprise,
  enterpriseDetail,
  staffDetail,
  userDetail,
  enterpriseDashboard,
  staff,
  enterprisePatients,
  enterpriseProducts,
  location,
  leadCapture,
  leadCaptureDetail,
  setUpPassword,
} from 'routes/AppUrls';

const publicRoutes = [
  {
    path: (locale) => login(locale),
    element: <Login />,
    isNoSidebar: true,
    isNoNavbar: true,
  },
  {
    path: (locale) => registerSuccess(locale),
    element: <RegisterSuccess />,
    isNoSidebar: true,
    isNoNavbar: true,
  },
  {
    path: (locale) => otp(locale),
    element: <Otp />,
    isNoSidebar: true,
    isNoNavbar: true,
  },
  {
    path: (locale) => setUpPassword(locale),
    element: <SetupPassword />,
    isNoSidebar: true,
    isNoNavbar: true,
  },
];

const privateRoutes = [
  {
    path: (locale) => dashboard(locale),
    element: <Dashboard />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: false,
    isPrivate: true,
    allowedRoles: ['super-admin'],
  },
  {
    path: (locale) => request(locale),
    element: <AdminRequest />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: false,
    isPrivate: true,
    allowedRoles: ['super-admin'],
  },
  {
    path: (locale) => appointments(locale),
    element: <Appointments />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: false,
    isPrivate: true,
    allowedRoles: ['super-admin'],
  },
  {
    path: (locale) => requestDetail(locale),
    element: <RequestDetail />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: false,
    isPrivate: true,
    allowedRoles: ['super-admin'],
  },
  {
    path: (locale) => doctor(locale),
    element: <DoctorList />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: false,
    isPrivate: true,
    allowedRoles: ['super-admin'],
  },
  {
    path: (locale) => doctorDetail(locale),
    element: <DoctorDetail />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: false,
    isPrivate: true,
    allowedRoles: ['super-admin'],
  },
  {
    path: (locale) => practices(locale),
    element: <PracticeList />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: false,
    isPrivate: true,
    allowedRoles: ['super-admin'],
  },
  {
    path: (locale) => practicesDetail(locale),
    element: <PracticeDetail />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: false,
    isPrivate: true,
    allowedRoles: ['super-admin'],
  },
  {
    path: (locale) => patients(locale),
    element: <PatientList />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: false,
    isPrivate: true,
    allowedRoles: ['super-admin'],
  },
  {
    path: (locale) => patientsDetail(locale),
    element: <PatientDetail />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: false,
    isPrivate: true,
    allowedRoles: ['super-admin'],
  },
  {
    path: (locale) => questionnaire(locale),
    element: <Questionnaire />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: false,
    isPrivate: true,
    allowedRoles: ['super-admin'],
  },
  {
    path: (locale) => questionnaireDetail(locale),
    element: <QuestionnaireDetail />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: false,
    isPrivate: true,
    allowedRoles: ['super-admin'],
  },
  {
    path: (locale) => products(locale),
    element: <Product />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: false,
    isPrivate: true,
    allowedRoles: ['super-admin'],
  },
  {
    path: (locale) => setting(locale),
    element: <Setting />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: false,
    isPrivate: true,
    allowedRoles: ['super-admin'],
  },
  {
    path: (locale) => revenueStream(locale),
    element: <Revenue />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: false,
    isPrivate: true,
    allowedRoles: ['super-admin'],
  },
  {
    path: (locale) => skinAnalyser(locale),
    element: <SkinAnalyser />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: false,
    isPrivate: true,
    allowedRoles: ['super-admin'],
  },
  {
    path: (locale) => skinAnalyserDetail(locale),
    element: <SkinAnalyserDetail />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: false,
    isPrivate: true,
    allowedRoles: ['super-admin'],
  },
  {
    path: (locale) => scanResult(locale),
    element: <ScanResult />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: false,
    isPrivate: true,
    allowedRoles: ['super-admin', 'enterprise-admin'],
  },
  {
    path: (locale) => enterprise(locale),
    element: <Enterprise />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: false,
    isPrivate: true,
    allowedRoles: ['super-admin'],
  },
  {
    path: (locale) => enterpriseDetail(locale),
    element: <EnterpriseDetail />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: false,
    isPrivate: true,
    allowedRoles: ['super-admin'],
  },
  {
    path: (locale) => staffDetail(locale),
    element: <StaffDetail />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: false,
    isPrivate: true,
    allowedRoles: ['super-admin', 'enterprise-admin'],
  },
  {
    path: (locale) => userDetail(locale),
    element: <UserDetail />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: false,
    isPrivate: true,
    allowedRoles: ['super-admin'],
  },
  {
    path: (locale) => enterpriseDashboard(locale),
    element: <EnterpriseDashboard />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: false,
    isPrivate: true,
    allowedRoles: ['enterprise-admin'],
  },
  {
    path: (locale) => staff(locale),
    element: <EnterpriseStaff />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: false,
    isPrivate: true,
    allowedRoles: ['enterprise-admin'],
  },
  {
    path: (locale) => enterprisePatients(locale),
    element: <EnterprisePatients />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: false,
    isPrivate: true,
    allowedRoles: ['enterprise-admin'],
  },
  {
    path: (locale) => location(locale),
    element: <EnterpriseLocation />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: false,
    isPrivate: true,
    allowedRoles: ['enterprise-admin'],
  },
  {
    path: (locale) => enterpriseProducts(locale),
    element: <EnterpriseProducts />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: false,
    isPrivate: true,
    allowedRoles: ['enterprise-admin'],
  },
  {
    path: (locale) => leadCapture(locale),
    element: <LeadCapture />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: false,
    isPrivate: true,
    allowedRoles: ['super-admin'],
  },
  {
    path: (locale) => leadCaptureDetail(locale),
    element: <LeadCaptureDetail />,
    isNoSidebar: false,
    isNoNavbar: false,
    isCommon: false,
    isPrivate: true,
    allowedRoles: ['super-admin', 'enterprise-admin'],
  },
];

const commonRoutes = [
  // {
  //   path: (locale) => dashboard(locale),
  //   element: <Dashboard />,
  //   isNoSidebar: false,
  //   isNoNavbar: false,
  //   isCommon: true,
  //   isPrivate: true,
  // },
];

export const allRoutes = [...publicRoutes, ...privateRoutes, ...commonRoutes];
